export const configs = {
    serverUrl: process.env.REACT_APP_SERVER_URL,
    fileServer: process.env.REACT_APP_FILE_SERVER
}